var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 6.00008C13.167 3.69841 11.302 1.83341 9.00033 1.83341C6.69866 1.83341 4.83366 3.69841 4.83366 6.00008C4.83366 8.30175 6.69866 10.1667 9.00033 10.1667C11.302 10.1667 13.167 8.30175 13.167 6.00008ZM17.3337 6.00008C16.0737 9.39591 12.9895 11.8334 9.00033 11.8334C5.01116 11.8334 1.92699 9.39591 0.666992 6.00008C1.92699 2.60425 5.01116 0.166748 9.00033 0.166748C12.9895 0.166748 16.0737 2.60425 17.3337 6.00008ZM11.5003 6.00008C11.5003 7.38091 10.3812 8.50008 9.00033 8.50008C7.61949 8.50008 6.50033 7.38091 6.50033 6.00008C6.50033 4.61925 7.61949 3.50008 9.00033 3.50008C10.3812 3.50008 11.5003 4.61925 11.5003 6.00008Z",
    fill: "#868B91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.10d1eee005274063843bb6667318f126.svg";
export { ForwardRef as ReactComponent };